let number = 0
export function usePageNumber(initNum) {
  number = initNum ?? number + 1;
  return number;
}
